var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2.51788L7.91965 6.29923L6.83929 7.91977L6.83929 13.6389C6.84079 13.8408 6.92165 14.034 7.06442 14.1768C7.20719 14.3196 7.4004 14.4004 7.6023 14.4019L10.3977 14.4019C10.5996 14.4004 10.7928 14.3196 10.9356 14.1768C11.0784 14.034 11.1592 13.8408 11.1607 13.6389L11.1607 7.91977L10.0804 6.29923L10.0001 2.51798",
    stroke: "black",
    strokeOpacity: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlass);
export default __webpack_public_path__ + "static/media/Glass.9de7833b988055565d6e764b5ce30bff.svg";
export { ForwardRef as ReactComponent };